import styled from 'styled-components';

export const StyledContainer = styled.section`
  width: 100%;
`;

export const StyledViewDealsContainer = styled.section`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: row;
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 30px;
  row-gap: 1em;
  width: 100%;
  padding: 0px;

  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const DealsHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  h1 {
    margin-right: auto;
  }
`;
export const SelectionToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font: 500 13px 'Archivo', sans-serif;
  color: ${({ theme }) => theme.textFaint};
  > label {
    cursor: pointer;
  }
`;
export const BatchBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  color: ${({ theme }) => theme.textFaint};
  font: 13px 'Archivo', sans-serif;
  > div {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  > p {
    width: 100%;
    margin: 0;
  }
  button {
    margin: 0;
  }
`;
export const DealSelection = styled.div`
  position: relative;
  width: 230px;
  max-width: 100%;
  min-width: 0;
  opacity: ${({ $unavailable }) => ($unavailable ? 0.35 : 1)};
  transition: opacity 0.15s;
  > div {
    pointer-events: ${({ $selecting }) => ($selecting ? 'none' : 'auto')};
  }
  > div > div {
    outline: ${({ $selected, theme }) =>
      $selected
        ? `2px solid ${theme.isDark ? theme.headerAccent : theme.success}`
        : 'none'};
    outline-offset: 3px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const SelectionCheck = styled.label`
  position: absolute;
  inset: 20px 0;
  z-index: 2;
  cursor: pointer;
  input {
    position: absolute;
    inset: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
  }
  input:disabled {
    cursor: default;
  }
  > span {
    position: absolute;
    top: -10px;
    right: -8px;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.border};
    background: ${({ theme }) => theme.card};
    transition: border-color 0.15s ease, background 0.15s ease;
  }
  > span::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: transparent;
    transition: background 0.15s ease;
  }
  input:checked + span {
    border-color: ${({ theme }) => theme.success};
  }
  input:checked + span::after {
    background: ${({ theme }) => theme.success};
  }
  input:disabled + span {
    display: none;
  }
  input:focus-visible + span {
    outline: 2px solid var(--tol-header-accent);
    outline-offset: 3px;
  }
`;
export const OfferSummary = styled.ul`
  width: 100%;
  list-style: none;
  margin: 4px 0 18px;
  padding: 0;
  max-height: 40vh;
  overflow-y: auto;
  color: ${({ theme }) => theme.text};
  font: 14px/1.5 'Archivo', sans-serif;
  li {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px 16px;
    padding: 10px 0;
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  }
  small {
    width: 100%;
    color: ${({ theme }) => theme.textFaint};
  }
  button {
    padding: 8px 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.textFaint};
    font: inherit;
    cursor: pointer;
  }
`;
